<template>
 <div>
        <h1>Domaine : {{ host.name }} </h1>

        <div>
            <h2 class='component_title'>Points d’entrée de ProLexis WebService : </h2>
            <h3>Si vous utilisez un plug-in <span class="red">V3</span> :</h3>
            <ul>
                <li>Point d’entrée de l’API SOAP : <a :href="'https://' + host.name +'/prolexisws/v3/ProLexisService'">https://{{ host.name }}/prolexisws/v3/ProLexisService</a></li>
                <li>WSDL l’API SOAP : <a :href="'https://'+host.name+'/prolexisws/v3/ProLexisService?WSDL'">https://{{ host.name }}/prolexisws/v3/ProLexisService?WSDL  </a></li>
            </ul>
            <h3>Si vous utilisez un plug-in <span class="red">V4</span> :</h3>
            <ul>
                <li>Point d’entrée de l’API SOAP : <a :href="'https://' + host.name +'/prolexisws/'+WS_Version+'/ProLexisService'">https://{{ host.name }}/prolexisws/{{WS_Version}}/ProLexisService</a></li>
                <li>WSDL l’API SOAP : <a :href="'https://'+host.name+'/prolexisws/'+WS_Version+'/ProLexisService?WSDL'">https://{{ host.name }}/prolexisws/{{WS_Version}}/ProLexisService?WSDL  </a></li>
            </ul>
        </div>


        <div v-if='host.authorizedAddress != undefined && host.authorizedAddress.length > 0'>
            <h2 class='component_title'>Adresses IPs autorisées : </h2>

            <div id="ipTab" class="pl-list">
                <div class="header">
                    <div class="header_line">
                        <div id="header_col1" class="header_col col1">IPs</div>
                        <div id="header_col2" class="header_col col2">Configuration</div>
                        <div id="header_col4" class="header_col col4">Note</div>
                    </div>
                </div>
            
                <div class="content" ref="ipsBox">
                    <ipline v-for="(ip) in host.authorizedAddress" :key='ip.id' :ipObj='ip'   ></ipline>

                    <div class="dummyline" :style="{'height': dummyIPHeight+'px'}">
                        <div class="col col1">&nbsp;</div>
                        <div class="col col2">&nbsp;</div>
                        <div class="col col4">&nbsp;</div>
                    </div>
                </div>
                <div class="footer">
                    <div class="buttons">
                        <button id="btn_addIP" type="button" class="liste_btn boutonTableau" title="Ajouter" @click="clickBtnAddIP()">Ajouter</button>
                    </div>
                </div>
            </div>

        </div>
        <div v-else>
            <br/>
            <a id="link_addIP" class="link_host" title="Ajouter" @click='clickBtnAddIP()'>Ajouter une IP</a>
        </div>
        <br/>
        <br/>

        <div v-if='host.apiKeys != undefined && host.apiKeys.length > 0'>
        <h2 class='component_title'>clés d'API autorisées : </h2>

            <div id="apiTab" class="pl-list">
                <div class="header">
                    <div class="header_line">
                        <div id="header_col1" class="header_col col1">clés d'API</div>
                        <div id="header_col2" class="header_col col2">Configuration</div>
                        <div id="header_col4" class="header_col col4">Note</div>
                    </div>
                </div>
            
                <div class="content" ref="apiBox">
                    <apiline v-for="(api) in host.apiKeys" :key='api.value' :apiObj='api'   ></apiline>

                    <div class="dummyline" :style="{'height': dummyAPIHeight+'px'}">
                        <div class="col col1">&nbsp;</div>
                        <div class="col col2">&nbsp;</div>
                        <div class="col col4">&nbsp;</div>
                    </div>
                </div>
                <div class="footer" >
                    <div class="buttons" v-if="isSuperAdmin()">
                        <button id="btn_addAPIKey" type="button" class="liste_btn boutonTableau" title="Ajouter" @click="clickBtnAddApiKey()">Ajouter</button>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <a id="link_addAPIKey" class="link_host"  title="Ajouter une clé d'API" @click='clickBtnAddApiKey()'>Ajouter une clé d'API</a>
        </div>

        <br/>
        <div id="warning">
            <i id="warning_icon" class="material-icons">warning_amber</i>
            <span id="warning_txt"> Tout changement dans cette page sera effectif <u>15 minutes</u> après avoir cliqué sur "Envoyer les modifs" en haut à droite.</span>
        </div>
    </div>
</template>

<script>
    import { diagonalbackURL, defaultConfig } from "../constantes";
    import { RoleEnum } from '../classes/enums'
    import FctUtils from '@/components/FctUtils';
    import IPLine from '@/components/IPLine';
    import APILine from '@/components/APILine';
    import axios from 'axios'
    
    export default {
        name:"Host",
        components:{
            "ipline":IPLine,
            "apiline":APILine,
        },
        mixins: [FctUtils],
        props :{
            hostId : {}
        },
        data(){
            return {
                host:{},
                dummyIPHeight:25,
                dummyAPIHeight:25,
                WS_Version : 'v4'
            }
        },
        created() {
            axios(diagonalbackURL + "/hosts/"+ this.hostId,  defaultConfig)
            .then(reponse => {
                this.host = reponse.data;
            })
            .catch(error => this.errorHandler(error));
        },
        mounted() {
            this.emitter.on('createIP', newIpData => {
                this.addIP(newIpData)
            });
            this.emitter.on('editIP', ipdata => {
                this.editIP(ipdata)
            });
            this.emitter.on('removeIP', ipdata => {
                this.removeIP(ipdata)
            });
            //
            this.emitter.on('createAPI', newAPIKData => {
                this.addAPIKey(newAPIKData)
            });
            this.emitter.on('editAPI', apidata => {
                this.editAPI(apidata)
            });
            this.emitter.on('removeAPI', apidata => {
                this.removeAPI(apidata)
            });
        },
        updated() {
            this.calcDummyIPHeight();
            this.calcDummyAPIHeight();
        }, 
        watch : {
            host: function (newQuestion, oldQuestion) {
                this.calcDummyIPHeight();
                this.calcDummyAPIHeight();
            },
        },
        methods : {
            isSuperAdmin(){
                return this.$store.state.currentUser.role == RoleEnum.SUPERADMIN.value;
            },
            //
            // Adresse IP
            //
            clickBtnAddIP(){
                this.emitter.emit('showPLForm', {mode: 'formIP_new'});
            },
            addIP(newIpData){
                console.log("Ajout d'une IP : "+newIpData.name)

                const params = JSON.stringify({
                    'ip':newIpData.name,
                    'active':newIpData.active,
                    'settingId':newIpData.settingId,
                    'note':newIpData.note
                });

                axios.put(diagonalbackURL + "/hosts/"+this.hostId+"/authorisations", params, defaultConfig)
                .then(reponse => {
                    this.$router.go();
                })
                .catch(error => {
                    this.errorHandler(error);
                    switch(error.response.status) {
                        case 304 : alert("Erreur IP déjà existante : " + newIpData.name);
                            break;
                        default :  alert("Erreur lors de l'ajout de l'IP : " + newIpData.name);
                            break;
                    }
                });
                
            },
            editIP(aIPData) {
                console.log("Modification d'une IP : " + aIPData.name)

                const params = JSON.stringify({
                    'ip':aIPData.name,
                    'active':aIPData.active,
                    'settingId':aIPData.settingId,
                    'note':aIPData.note
                });

                axios.post(diagonalbackURL + "/authorisations/"+aIPData.id, params, defaultConfig)
                .then(reponse => {
                    this.$router.go();
                })
                .catch(error => {
                    this.errorHandler(error)
                    alert("Erreur lors de la modification de l'IP : " + aIPData.name);
                });
            },
            removeIP(aIPData) {
                console.log("Suppression d'une IP : " + aIPData.name)

                axios.delete(diagonalbackURL + "/authorisations/"+ aIPData.id,  defaultConfig)
                .then(reponse => {
                    this.$router.go();
                })
                .catch(error => this.errorHandler(error));
            },
            //
            // clé d'API
            //
            clickBtnAddApiKey(){
                this.emitter.emit('showPLForm', {mode: 'formAPI_new'});
            },
            addAPIKey(newAPIKData){
                console.log("Ajout d'une clé d'API : "+newAPIKData.name)

                const params = JSON.stringify({
                    'value':newAPIKData.name,
                    'active':newAPIKData.active,
                    'note': newAPIKData.note,
                    'settingId':newAPIKData.settingId 
                });
                
                axios.put(diagonalbackURL + "/hosts/"+this.hostId+"/apikeys", params, defaultConfig)
                .then(reponse => {
                    this.$router.go();
                })
                .catch(error => {
                    this.errorHandler(error)
                    alert("Erreur lors de l'ajout de la clé d'API : " + newAPIKData.name);
                });
                
            },
            editAPI(aAPIData) {
                console.log("Modification d'une clé d'api : " + aAPIData.name)
                const params = JSON.stringify({
                    'value':aAPIData.name,
                    'active':aAPIData.active,
                    'note': aAPIData.note,
                    'settingId':aAPIData.settingId 
                });

                axios.post(diagonalbackURL + "/apikeys/"+aAPIData.id, params, defaultConfig)
                .then(reponse => {
                    this.$router.go();
                })
                .catch(error => {
                    this.errorHandler(error);
                    alert("Erreur lors de la modification de la clé d'API : " + aAPIData.name);
                });

            },
            removeAPI(aAPIData) {
                console.log("Suppression d'une clé d'api : " + aAPIData.name)
                
                axios.delete(diagonalbackURL + "/apikeys/"+aAPIData.id,  defaultConfig)
                .then(reponse => {
                    this.$router.go();
                })
                .catch(error => this.errorHandler(error));  
            },
            //
            //
            calcDummyIPHeight() {
                var calcHeight = 25;

                if (this.$refs.ipsBox != undefined && this.host.authorizedAddress.length != undefined) {
                    calcHeight = this.$refs.ipsBox.scrollHeight - (this.host.authorizedAddress.length*27); 
                }

                this.dummyIPHeight = calcHeight;
            },
            calcDummyAPIHeight() {
                var calcHeight = 25;

                if (this.$refs.apiBox != undefined && this.host.apiKeys.length != undefined) {
                    calcHeight = this.$refs.apiBox.scrollHeight - (this.host.apiKeys.length*27);
                }

                this.dummyAPIHeight = calcHeight;
            },

        },
        unmounted() {
            this.emitter.off('createIP');
            this.emitter.off('editIP');
            this.emitter.off('removeIP');
            //
            this.emitter.off('createAPI');
            this.emitter.off('editAPI');
            this.emitter.off('removeAPI');
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >

.link_host {
    cursor: pointer;
    font-size:12pt;
    color:#0075bb;
}

.component_title {
    margin-bottom:10px;
}


/* IP table */

#ipTab.pl-list .col2 {
    width: 140px;
}

#ipTab.pl-list .col4, #apiTab.pl-list .col4 {
    border-right: none;
    border-left-width: 1px;
    width:auto;
}

/* API Table */

#apiTab.pl-list .col1 {
    width: 321px;
}

#apiTab.pl-list .col2 {
    width: 140px;
}

#apiTab.pl-list .col3 {
    border-right: none;
}
</style>
